import { db } from './firebase.service';
import {
  collection,
  query,
  doc,
  addDoc,           // Create
  updateDoc,        // Update
  deleteDoc,        // Delete
  // CollectionReference,
  orderBy,          // 정렬
  onSnapshot        // 실시간 문서 대기
} from 'firebase/firestore';

const workoutCollectionRef = collection(db, 'workouts'); // collection(db, '컬렌션')
const workoutDoc = (id: string) => doc(db, 'workouts', id); // collection(db, '컬렉션', id);
export const q = query(workoutCollectionRef, orderBy('timestamp', 'desc')); // query(collection, orderBy(시간, 내림차순))

const workoutService = {
  // Create
  async addWorkout(workout: string, isCompleted: boolean, timestamp: number) {
    try {
      await addDoc(workoutCollectionRef, {
        workout: workout,
        isCompleted: isCompleted,
        timestamp: timestamp
      });
    } catch (error) {
      console.log(error)
    }
  },

  // Update
  async updateWorkout(id:string, workout: string, isCompleted: boolean) {
    try {
      await updateDoc(workoutDoc(id), {
        workout: workout,
        isCompleted: isCompleted
      });
    } catch (error) {
      console.log(error);
    }
  },

  // Delete
  async deleteWorkout(id: string) {
    try {
      await deleteDoc(workoutDoc(id));
    } catch (error) {
      console.log(error);
    }
  }
};

export default workoutService;